// ThemeCssVarsInjector.tsx
import { GlobalStyles } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ThemeCssVarsInjector = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        ":root": {
          "--primary-main": theme.palette.primary.main,
          "--primary-light": theme.palette.primary.light,
          "--primary-dark": theme.palette.primary.dark,
          "--error-main": theme.palette.error.main,
          "--orange-accent": theme.colors?.primary?.main || "#43463B", // fallback
        },
      }}
    />
  );
};

export default ThemeCssVarsInjector;
